import TreeItem from './TreeItem/TreeItem';
import { NavigableTreeNode } from '../types';

interface TreeItemGroupProps {
  nodes: NavigableTreeNode[];
  level: number;
  label?: string;
}

export default function TreeItemGroup({
  nodes,
  level,
  label,
}: Readonly<TreeItemGroupProps>) {
  if (!nodes || nodes.length === 0) {
    return null;
  }

  return (
    <ul
      aria-label={label}
      {...{ role: level === 0 ? 'tree' : 'group' }}
      style={{ listStyle: 'none', padding: 0, margin: 0 }}
    >
      {nodes.map((node) => (
        <TreeItem key={node.nodeId} node={node} level={level} />
      ))}
    </ul>
  );
}
